import { tv } from 'tailwind-variants';

export const entityActionStyle = tv({
  base: 'h-10 rounded-lg bg-green-100 flex items-center justify-center hover:bg-green-200 disabled:opacity-50',
  variants: {
    variant: {
      icon: 'w-10 shrink-0',
      labeled: 'flex-1 min-w-0 gap-2 px-4 py-2 text-base font-semibold text-green-500',
    },
  },
  defaultVariants: {
    variant: 'icon',
  },
});
